import { PortableTextBodyElement } from './blockContent'
import { BlockTitleOverride, getBlockTitlesAndIds } from './blockId'
import { Translations } from './localization'

export type AnchorLinkBlock = {
  block?: string | null
  title?: string | null
}

export type GetBlockAnchorListProps = {
  anchorLinkBlocks?: AnchorLinkBlock[]
  filteredContent: PortableTextBodyElement[]
  translations: Translations
}

export const getBlockAnchorList = ({
  anchorLinkBlocks,
  filteredContent,
  translations,
}: GetBlockAnchorListProps) => {
  const blockTitleOverrides =
    anchorLinkBlocks?.map<BlockTitleOverride>(block => ({
      _key: block.block ?? '',
      title: block.title ?? undefined,
    })) ?? undefined

  return getBlockTitlesAndIds(filteredContent, blockTitleOverrides, translations)
}
